const STATUS_STARTED = 'started';
const STATUS_SUBMITTED = 'submitted';
const STATUS_READY_SUBMIT = 'readySubmit';

export {
  STATUS_STARTED,
  STATUS_SUBMITTED,
  STATUS_READY_SUBMIT
};
